import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { DismissButton, useOverlay } from '@react-aria/overlays';
export const Popover = (props) => {
    const ref = React.useRef(null);
    const { popoverRef = ref, isOpen, onClose, children } = props;
    // Handle events that should cause the popup to close,
    // e.g. blur, clicking outside, or pressing the escape key.
    const { overlayProps } = useOverlay({
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
        isDismissable: true,
    }, popoverRef);
    // Add a hidden <DismissButton> component at the end of the popover
    // to allow screen reader users to dismiss the popup easily.
    return (_jsxs("div", Object.assign({ className: "absolute z-[2] w-full outline-0" }, overlayProps, { ref: popoverRef, children: [children, _jsx(DismissButton, { onDismiss: onClose })] })));
};
